











import { IItem, instanceOfIQuotable } from "../../../../../../../domain/document/items";
import { Component, Mixins, Prop } from "vue-property-decorator";

@Component
export default class QuotedBadge extends Mixins() {
  @Prop()
  source: IItem;

  get isQuotedItem(): boolean {
    return !!this.source 
      && instanceOfIQuotable(this.source)
      && this.source.isQuoted;
  }
}
